// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XUbt","title":"Header_title__3MFul","left":"Header_left__3Q9JK","clinicName":"Header_clinicName__1Klqi"};